module.exports = __webpack_public_path__ + "img/morenditu.653b77ca.png";